import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="redirection-manager"
export default class extends Controller {

  static values = {
    deleteRedirectCookie: Boolean,
  }
  connect() {
    const currentPath = window.location.href
    const hostname = window.location.hostname
    const mainDomain = hostname.includes('.') ?
      `.${hostname.split('.').slice(-2).join('.')}` :
      hostname

    if (this.deleteRedirectCookieValue) {
      document.cookie = `return_to=; path=/; domain=${mainDomain}`
    }else {
      document.cookie = `return_to=${encodeURIComponent(currentPath)}; path=/; domain=${mainDomain}`
    }
  }
}
